import { es } from "vuetify/locale";

export default {
    ...es,

    "alert": "Atención",
    "add": "Añadir",
    "back": "Volver",
    "cancel": "Cancelar",
    "clear": "Borrar",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "next": "Siguiente",
    "save": "Guardar",
    "send_email": "Enviar",
    "help_country_code": "Código País",
    "help_search_country": "Buscar un país",
    "help_mobile_number": "Móvil",
    "help_example": "Ejemplo",
    "earned": "Acumulado",
    "info": "Info",
    "ingredients": "Ingredientes",
    "info_nutritional": "Información Nutricional",
    "remove": "Eliminar",
    "removeall": "Eliminar Todos",

    "campaigns": "Campañas",
    "highlights": "Destaques",
    "home": "Comienzo",
    "items": "Artículos",
    "map": "Mapa",
    "address": "Dirección",
    "settings": "Definiciones",
    "store": "Tienda",
    "stores": "Donde Estamos",
    "support": "Soporte",
    "user": "Perfil",
    "offers": "Ofertas",
    "qrcode": "Código QR",
    "transactions": "Movimientos",

    "generic_error": "Contenido no disponible actualmente",
    "mandatory": "Obligatorio",
    "missing": "Faltan",
    "no_movements_to_display": "Aún no hay movimientos registrados",
    "phone_number": "Móvil",
    "points": "Puntos",
    "spent": "Gastado",
    "next_point": "siguiente punto",
    "qrcode_show_message": "Mostrar este código en la tienda",
    "stores_not_available": "No hay tiendas disponibles",
    "thank_you": "¡Gracias!",
    "total": "Total",
    "transactions_detail": "Detalle",
    "user_profile_updated_success": "Perfil Actualizado con Éxito",
    "user_welcome": "Hola",

    "id_document": "Número",
    "id_document_type": "Doc. de Identificación",

    "profile": {
        "birth_date": "Fecha de Nacimiento",
        "birth_date_required": "Fecha de Nacimiento Obligatoria",
        "birth_date_minors": "Fecha de Nacimiento inválida, los menores están excluidos",
        "citizen_card_size": "Debe tener 12 digitos",
        "communication_preferences": "Preferencia de Comunicación",
        "email_required": "E-mail Obligatorio",
        "email_invalid": "E-mail Inválido",
        "favourite_store": "Tienda Favorita",
        "gender": "Género",
        "gender_male": "Masculino",
        "gender_female": "Femenino",
        "gender_other": "Otro",
        "gender_required": "Género Obligatorio",
        "id_document_required": "Número de Documento de Identificación Obligatorio",
        "id_document_type_empty": "Debe seleccionar el tipo de documento",
        "identity_card_size": "Debe tener 9 digitos",
        "name": "Nombre",
        "name_invalid": "El nombre deve ter en el máximo 20 caracteres",
        "name_invalid_two_names": "Primero y Último Nombre",
        "name_required": "Nombre Obligatorio",
        "number_invalid": "Número Invalido",
        "passport_size": "Debe tener 8 dígitos",
        "phone_number_required": "Móvil Obligatorio",
        "phone_nine_digits": "Móvil debe tener 9 digitos",
        "tax_number": "NIF",
        "tax_number_nine_digits": "NIF deve tener 9 digitos",
        "tax_number_invalid": "NIF Inválido",
    },

    "gdpr_agreement": {
        "agreement_mandatory": "Para continuar debe aceptar la configuración de privacidad.",
        "agreement_communication_means_mandatory": "Para continuar debe aceptar los canales de comunicación.",
        "gdpr_agreement": "Términos y Condiciones",
        "gdpr_agreement_accept": "He leído y acepto los Términos y Condiciones, así como la Protección de Datos Personales.",
        "gdpr_agreement_agree": "Concuerdo",
        "gdpr_agreement_disagree": "No Concuerdo",
        "program_terms_policy": "Condiciones Generales del Programa de Fidelización",
        "terms_policy": "Términos, condiciones y políticas de privacidad",
        "gdpr_agreement_revoke": "El consentimiento para registrar datos personales ha sido revocado con éxito. Sus datos serán eliminados.",
    },

    "authentication": {
        "login_error": "No fue posible validar el usuario y el código indicados. Inténtalo de nuevo.",
        "end_session": "Sesión finalizada",
        "login_step_user_title": "Ingrese su móvil",
        "login_step_user_subtitle": "Si aún no está registrado le enviaremos un SMS con un código de acceso para completar su registro.",
        "login_step_password_title": "Ingrese su código de acceso",
        "login_step_newuser_password_subtitle": "Verifique el código de acceso en el SMS que se le envió. Este código es necesario para volver a autenticarse. Puede cambiarlo en su perfil después de completar su registro.",
        "logout": "Cerrar Sessión",
        "new_register": "Nuevo Registro",
        "new_user": "¿Nuevo usuario?",
        "register_now": "Registrarse ahora",
        "password": "Código de Acceso",
        "password_change": "Cambiar Código de Acceso",
        "password_old": "Código de Acceso Actual",
        "password_new": "Nuevo Código de Acceso",
        "password_new_success_sent": "Nuevo Código de Acceso enviado enviado a su móvil",
        "password_bigger_than8": "Debe tener al menos 8 caracteres;",
        "password_bigger_than10": "Debe tener al menos 10 caracteres;",
        "password_lower_case": "Debe incluir una minúscula;",
        "password_one_number": "Debe incluir un dígito.",
        "password_special_char": "Debe incluir un personaje especial.",
        "password_upper_case": "Debe incluir una mayúscula;",
        "password_recover": "Enviar nuevo código de acceso",
        "password_required": "Código de Accesso Obligatório",
        "username_nine_digits": "El móvil debe tener 9 dígitos",
        "phone_number_invalid": "Móvil Inválido",
        "password_change_success": "Código de acceso cambiado correctamente"
    },

    "vouchers": {
        "vouchers": "Vales",
        "voucher_due_date": "Duracion",
        "voucher_available_at": "Valido En",
        "voucher_emitted": "Vale Emitido",
        "voucher_offers": "Vales Y Ofertas",
        "voucher_rescued": "Vale Rescatado",
    },

    "shop": {
        "shop_cart": "Cesta",
        "shop_cart_pay": "Pagamento",
        "shop_cart_checkout": "Tramitar Pedido",
        "shop_cart_submit": "Tramitar Pedido",
        "shop_cart_items": "Artículos en la Cesta",
        "shop_cart_empty": "Tu cesta está vacía",
        "shop_cart_items_unavailable": "Algunos articulos de la cesta están indisponibles.",
        "shop_item_added_to_cart": "Artículo añadido a la cesta",
        "shop_item_remove_from_cart": "Artículo se ha eliminado de la cesta",
        "shop_item_stock": "Artículo Disponible",
        "shop_item_nostock": "Artículo Indisponible",
        "order_successfully_submited": "Pedido Registrado Correctamente",
        "buy": "Comprar",
        "payment_method": "Método de Pagamento",
        "shipping_costs": "Gastos de Envío",
        "shipping_method": "Opciones de Envío",
        "shipping_location": "Local de Recogida",
        "my_orders": "Mis Pedidos",
        "catalog": "Tienda",
        "order_resume_comments": "Comentarios",
        "order_resume_choose_date": "Escojer la Fecha",
        "delivery_options": "Opciones de Entrega",
        "delivery_not_available": "Delivery Options Not Available",
        "order_resume": "Confirmacion del Pedido",
        "order_pay": "Pagamento",
        "order_payment_entity": "Entidade",
        "order_payment_reference": "Referência",
        "order_payment_value": "Valor",
        "order_payment_success": "Pagamento Verificado com Sucesso",
        "order_payment_pending": "A Aguardar Validação do Pagamento",
        "order_payment_error": "Não foi possível validar o Pagamento",
        "order_complete": "Encomenda Finalizada com Sucesso!",
        "exceeded_daily_orders": "Se ha alcanzado la cantidad maxima de pedidos",
        "item_details_view": "Detalles",
        "item_define_menu": "O Meu Menu",
        "item_define_menu_extra": "Opciones",
        "remember_orders_in_progress": "Comprobe el estado de sus pedidos",
        "remember_shop_cart": "Tu cesta te está esperando",
        "promo_valid_until": "Promoción válida hasta",
    },

    "id_document_types": {
        "citizen_card": "Tarjeta Ciudadana",
        "identity_card": "Cédula de identidad",
        "passport": "Pasaporte",
        "residence_permit": "Autorización de residencia",
    },

    "qr_scanner": {
        "scan_qr_code": "Escanear Código QR",
        "camera_denied": "Se denegó el acceso a la cámara. Por favor, permita el acceso.",
        "camera_not_found": "No se encontró ninguna cámara en este dispositivo.",
        "camera_in_use": "La cámara ya está siendo utilizada por otra aplicación.",
        "camera_not_supported": "La cámara no es compatible con este dispositivo.",
        "camera_error": "Error de cámara: ",
        "scanned_document": "Documento Escaneado",
        "document_number": "Número de Documento",
        "date": "Fecha",
        "total": "Total",
        "qr_code_data": "Datos del Código QR",
        "parse_error": "No se pudo interpretar el formato ATCUD. Datos originales:",
        "no_data": "No se recibieron datos de código QR.",
        "add_purchase": "Añadir Compra",
        "purchase_added": "Compra añadida correctamente",
        "purchase_error": "Se produjo un error al añadir la compra",
    }
}